import { ITweekClient, DetailedTweekResult, TweekClient } from 'tweek-client';
import { logger } from '@soluto-home-web/platform-utils';
import { GetValuesConfig } from 'tweek-client/src/TweekClient/types';

export default class TweekClientWithFallback implements ITweekClient {
  constructor(private _clients: TweekClient[]) {}

  private async _fetchWithFallbacks<T>(method: keyof ITweekClient, path: string, config?: GetValuesConfig): Promise<T> {
    for (let client of this._clients) {
      try {
        return await (client[method] as any)(path, config);
      } catch (error) {
        console.error('tweek error', error);
        logger.warning('Caught exception during fetch from Tweek: ', {
          error,
          baseUrl: client.config.baseServiceUrl,
          path,
          config,
        });
      }
    }
    logger.warning(`Failed to ${method} from all Tweek fallbacks`, { path, config });
    throw `Failed to ${method} from all Tweek fallbacks`;
  }

  async fetch<T>(path: string, config?: GetValuesConfig): Promise<T> {
    if (globals.REACT_APP_IS_E2E) throw 'e2e';
    return await this._fetchWithFallbacks<T>('fetch', path, config);
  }

  async getValues<T>(path: string, config?: GetValuesConfig): Promise<T> {
    if (globals.REACT_APP_IS_E2E) throw 'e2e';
    return await this._fetchWithFallbacks<T>('getValues', path, config);
  }

  async getValuesWithDetails<T>(path: string, config?: GetValuesConfig): Promise<DetailedTweekResult<T>> {
    if (globals.REACT_APP_IS_E2E) throw 'e2e';
    return await this._fetchWithFallbacks<DetailedTweekResult<T>>('getValuesWithDetails', path, config);
  }
}



// WEBPACK FOOTER //
// ./packages/platform-core/tweek/TweekClientWithFallback.ts